import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  DROPDOWN_TOGGLE: `${cleanedFilename(__filename)}-dropdown-toggle`,
  DROPDOWN_LABEL: `${cleanedFilename(__filename)}-dropdown-label`,
  DROPDOWN_ERROR: `${cleanedFilename(__filename)}-dropdown-error`,
};
